import React from 'react'
import background_image from "../../assets/images/PQ-icon-white.png"

const BlueBanner = ({ data }) => {
    const { title, icon, content, includeLogo } = data

    let hasLogo = null;

    if (includeLogo) {
        hasLogo = 'hasLogo'
        return (
            <section className={`blue-banner ${hasLogo}`} style={{ backgroundImage: `url(${background_image})`}}>
                <div className="content">
                    {title && (
                        <h3>{title}</h3>
                    )}
                    {content && (
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                    )}
                </div>
            </section>
        )
    } else {
        return (
            <section className="blue-banner">
                <div className="content">
                    <div className="title">
                        {icon && (
                            <div className="icon-wrapper">
                                <img 
                                    src={icon?.localFile?.childImageSharp?.fixed?.src}
                                />
                            </div>
                        )}
                        {title && (
                            <h5>{title}</h5>
                        )}
                    </div>
                    {content && (
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                    )}
                </div>
            </section>
        )
    }
}

export default BlueBanner
